import { lazy, Suspense } from 'react'
import { Navigate, Route } from 'react-router-dom'

import { Loader } from '@ds'
import { LayoutTheme } from '@store'

import { ProtectedRoute } from '../../RoutesGuard'
import { LayoutWrapper } from './quests/layout/LayoutWrapper'
import {
  BattlePass,
  Friends,
  HomeView,
  Profile,
  Settings,
  ShadowView,
  Shop,
  Leaderboard,
  ReferralsView,
  RewardsView,
} from './views'

const Prologue = lazy(() => import('./views/prologue'))

export default (
  <Route key="game">
    <Route path="/" element={<Navigate to="/home" replace />} />
    <Route
      path="/home"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <HomeView />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />
    <Route
      path="/prologue"
      element={
        <LayoutWrapper layoutTheme={LayoutTheme.UI}>
          <Suspense fallback={<Loader />}>
            <Prologue />
          </Suspense>
        </LayoutWrapper>
      }
    />
    <Route
      path="/shadow"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <ShadowView />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />
    <Route
      path="/profile"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <Profile />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />
    <Route
      path="/shop"
      element={
        <LayoutWrapper layoutTheme={LayoutTheme.UI}>
          <Shop />
        </LayoutWrapper>
      }
    />
    <Route
      path="/battle-pass"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <BattlePass />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />

    <Route
      path="/leaderboard"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <Leaderboard />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <Settings />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />
    <Route
      path="/friends"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <ReferralsView />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />

    <Route
      path="/rewards"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <RewardsView />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />

    <Route
      path="/referrals"
      element={
        <ProtectedRoute>
          <LayoutWrapper layoutTheme={LayoutTheme.UI}>
            <ReferralsView />
          </LayoutWrapper>
        </ProtectedRoute>
      }
    />

    {/* <Route path="/collection/:slug" element={<CollectionView />} /> */}
  </Route>
)
